
import React, {Component} from 'react'
import {Box} from 'reactjs-admin-lte'
import {ButtonToolbar,Button,FormControl,FormGroup,Row,Col,ControlLabel} from 'react-bootstrap'
import Select from 'react-select'
import DatePicker from 'component/element/DatePicker'
import Moment from 'moment'
import FontAwsome from 'react-fontawesome'
import WorkdocStore from 'stores/WorkdocStore'
import ConfirmPopup from 'component/element/ConfirmPopup'
import CkTimePicker from 'component/element/CkTimePicker'

var NotificationSystem = require('react-notification-system');
const TODAY = Moment().format('L').replace(Moment().format('YYYY'), parseInt(Moment().format('YYYY')) + 543)
class NotificationScheduleConfig extends Component {

  constructor(...args) {
    super(...args)
    this.state = {loading:false,data:[],sending:false,showConfirm:false,indexDel:undefined,mobileNo:this.props.mobileNo}
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem
    this.loadData()
  }

  componentWillMount(){
    if(this.props.onRef!==undefined){
      this.props.onRef(this)
    }
  }  

  componentWillReceiveProps(newProps) {
    
  }

  setMobileNo(mobileNo){
      this.setState({mobileNo:mobileNo})
  }

  loadData() {
    this.setState({loading:true})
    WorkdocStore.loadWorkdocRelated(this.props.workNo,'notification_sms',(result)=>{
        let data = result.data.map((item,index)=>{
            return Object.assign({time:'09:00',bf_notification_id:'',send_status:'',send_date:'',notice_type:'IN_SYSTEM'},item,{mobile_no:this.state.mobileNo})            
        })
        this.setState({loading:false,data:data})
    },()=>{
        this.setState({loading:false})
    })
  }

  newEmptyRow(number){
    return new Array(number).fill(null).map((item,index)=>{
      return {bf_notification_id:'',notice_date:'5M',notice_type:'IN_SYSTEM',date:TODAY,time:'09:00',message:this.props.defaultText,send_date:'',send_status:'',mobile_no:this.state.mobileNo}
    })
  }

  getTextCount(index) {
    let {data} = this.state
    return data[index].message.length
  }

  onSaveClick(newData) {
    
    if(newData===null){
        newData = this.state.data
    }
    WorkdocStore.saveWorkdocRelated(this.props.workNo,'notification_sms',newData,(result)=>{
        if (result.status=='OK') {
            
            this.setState({data:result.data.detail})
            this._notificationSystem.addNotification({
                title:'แจ้งเตือน',
                message:'บันทึกรายการเรียบร้อยแล้ว',
                level:'info',
                position:'tc'
            });
        }
    },()=>{

    })
  }

  onCloseClick() {

  }

  onNoticeDateChange(index,e) {
    let {data} = this.state
    data[index].notice_date = e.value
    
    let dayAdd = 0 
    if (e.value=='30D')
        dayAdd = 30
    else if (e.value=='45D')
        dayAdd = 45
    else if (e.value=='2M')
        dayAdd = 60   
    else if (e.value=='3M')
        dayAdd = 90
    else if (e.value=='4M')
        dayAdd = 120
    else if (e.value=='5M')
        dayAdd = 150
    else if (e.value=='6M')
        dayAdd = 180           
    
    let new_date = Moment(TODAY, 'DD-MM-YYYY').add(dayAdd, 'days')
    let day = new_date.format('DD')
    let month = new_date.format('MM')
    let year = new_date.format('YYYY')
    data[index].date = day+'/'+month+'/'+year
        
    this.setState({data:data})
  }

  onNoticeTypeChange(index,e) {
    let {data} = this.state
    data[index].notice_type = e.value
    this.setState({data:data})
  }

  onDateChange(index,e) {
    let {data} = this.state
    data[index].date = e
    this.setState({data:data})
  }

  onTimeChange(index,e) {
    let {data} = this.state
    data[index].time = e
    this.setState({data:data})
  }  

  onTextChange(index,key,e) {
    let {data} = this.state
    data[index][key] = e.target.value
    this.setState({data:data})
  }

  onRowAdd(number){
    let {data} = this.state
    if (data.length==0)
        data = this.newEmptyRow(number)
    else    
        data = data.concat(this.newEmptyRow(number))

    this.setState({data:data})
  }

  onSendClick(item,index){
      let {sending,data} = this.state
      
      this.setState({data:data})
      if(this.state.mobileNo!==undefined && this.state.mobileNo!==''){
          data[index].send_status = 'กำลังส่ง...'
          let postData = {mobile_no:this.state.mobileNo,message:item.message,work_no:this.props.workNo}
            WorkdocStore.sendSMS(postData,(result)=>{
                if(result.status==='OK'){
                    data[index].bf_notification_id = result.bf_notification_id
                    data[index].send_date = Moment().format('DD/MM/YYYY HH:mm')
                    data[index].send_status = 'ส่งเรียบร้อย'     
                    this.onSaveClick(data)               
                }else{
                    data[index].send_status = 'Error:'+result.desc
                }
                this.setState({sending:false,data:data})
            },(error)=>{
                data[index].send_status = 'ส่งผิดพลาด...'
                this.setState({sending:false,data:data})
            })
      }else{
        data[index].send_status = 'เบอร์มือถือว่าง...'
      }
  }

  onDelClick(index) {
    let {indexDel} = this.state
    indexDel = index
    this.setState({indexDel:indexDel,showConfirm:true})
  }

  onConfirmDel() {
    let {data,indexDel} = this.state
    if (data[indexDel].bf_notification_id!=''&&data[indexDel].bf_notification_id!=undefined&&data[indexDel].bf_notification_id!=null) {
        WorkdocStore.delSms(data[indexDel].bf_notification_id,(result)=>{
            if (result.status=='OK') {
                data.splice(indexDel, 1)
                this.setState({data:data,indexDel:undefined,showConfirm:false})
            }
        },()=>{
            this.setState({data:data,indexDel:undefined,showConfirm:false})
        })
    } else {
        data.splice(indexDel, 1)
        this.setState({data:data,indexDel:undefined,showConfirm:false})
    }    
  }

  renderRowData() {
    let {data} = this.state
    if (data.length==0) {
        return(<tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
    } else {
        return(
            data.map((item,index)=>{
                return(
                    <tr key={index}>
                        <td style={{verticalAlign:'middle'}}>
                            <Row>
                                <Col md={12}>
                                    <FormGroup>
                                        <ControlLabel><br/></ControlLabel>
                                        <Select
                                            clearable={false}
                                            name="form-field-name"
                                            value={item.notice_type}
                                            options={[{label:'เตือนในระบบ',value:'in_system'},{label:'SMS ลูกค้า',value:'sms'}]}
                                            onChange={this.onNoticeTypeChange.bind(this,index)}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>            
                        </td>
                        <td style={{verticalAlign:'middle'}}>
                            <Row>
                                <Col md={4}>
                                    <FormGroup>
                                        <ControlLabel>แจ้งเตือนในอีก :</ControlLabel>
                                        <Select
                                            disabled={item.send_date==''||item.send_date==undefined?false:true}
                                            clearable={false}
                                            name="form-field-name"
                                            value={item.notice_date}
                                            options={[{label:'ส่งทันที',value:'NOW'},{label:'30 วัน',value:'30D'},{label:'45 วัน',value:'45D'},{label:'2 เดือน',value:'2M'},{label:'3 เดือน',value:'3M'},{label:'4 เดือน',value:'4M'},{label:'5 เดือน',value:'5M'},{label:'6 เดือน',value:'6M'},{label:'เลือกวันที่เอง',value:'CUSTOM'}]}
                                            onChange={this.onNoticeDateChange.bind(this,index)}
                                        />
                                    </FormGroup>    
                                </Col>    
                                <Col md={4}>
                                    <FormGroup>
                                        <ControlLabel>วันที่ส่ง :</ControlLabel>
                                        <DatePicker
                                            disabled={item.send_date==''||item.send_date==undefined?false:true}
                                            showFooter={true}
                                            popPlacement='bottom'
                                            value={item.date} 
                                            maxWidth={'100%'}
                                            inline={true}
                                            onChange={this.onDateChange.bind(this,index)}
                                            showIcon={true}
                                        />
                                    </FormGroup>    
                                </Col>
                                <Col md={4} style={{display:(item.notice_type=='in_system'?'none':'')}}>
                                    <FormGroup>
                                        <ControlLabel>เวลาที่ส่ง :</ControlLabel>
                                        <CkTimePicker
                                            disabled={item.send_date==''||item.send_date==undefined?false:true}
                                            value={item.time}
                                            onTimeSaved={this.onTimeChange.bind(this,index)}
                                            showIcon={true}
                                            minuteStep={5}
                                        />
                                    </FormGroup>    
                                </Col>
                            </Row>
                        </td>
                        <td>
                            <FormGroup controlId={''} validationState={this.getTextCount(index)>70?'error':null}>
                                <FormControl 
                                    disabled={item.send_date!==''||item.notice_type=='IN_SYSTEM'?true:false} 
                                    componentClass={'textarea'} 
                                    rows={3} 
                                    value={item.message} 
                                    onChange={this.onTextChange.bind(this,index,'message')} 
                                    style={{color:(this.getTextCount(index)>70?'red':'')}}
                                />
                            </FormGroup>
                            <div className='text-right' style={{color:(this.getTextCount(index)>70?'red':'')}}>
                                {this.getTextCount(index)} / 70
                            </div>
                        </td>
                        <td className='text-center' style={{verticalAlign:'middle'}}>{item.send_date}</td>
                        <td className='text-center' style={{verticalAlign:'middle'}}>{(item.notice_date=='NOW' && item.send_status==='')?<Button bsStyle='primary' onClick={this.onSendClick.bind(this,item,index)}><FontAwsome name='send' />&nbsp;ส่ง</Button>:item.send_status}</td>
                        <td className='text-center' style={{verticalAlign:'middle'}}>
                            <div style={{display:item.send_date!==''?'none':''}}>
                                <Button onClick={this.onDelClick.bind(this,index)} bsStyle={'danger'}><FontAwsome name='trash' /></Button>
                            </div>
                        </td>
                    </tr>    
                )
            })
        )    
    }
  }

  renderTable() {
      return(
          <div>
            <table className='table table-bordered-solid'>
                <thead>
                    <tr>
                        <th className='text-center' style={{width:'120px'}}>ประเภทการแจ้งเตือน</th>
                        <th className='text-center' style={{width:'350px'}}>วัน/เวลา</th>
                        <th className='text-center' style={{width:'280px'}}>ข้อความ</th>
                        <th className='text-center' style={{width:'50px'}}>วันที่ส่ง</th>
                        <th className='text-center' style={{width:'50px'}}>สถานะ</th>
                        <th className='text-center' style={{width:'50px',minWidth:'50px'}}>ลบ ?</th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderRowData()}
                </tbody>
            </table>
          </div>    
      )
  }

  renderNewItemButton(){
    return (
        <Row style={{marginTop:'10px'}}>
            <Col md={12}>
                <ButtonToolbar>
                    <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwsome name='plus'/>&nbsp;เพิ่มรายการ</Button>
                </ButtonToolbar>
            </Col>    
        </Row>
    )
  }

  render() {
    let {loading} = this.state
    let {alertType} = this.props
    let title = 'แจ้งเตือนในระบบ'
    if(alertType=='sms'){
        title = `แจ้งเตือนผ่าน SMS หมายเลข this.state.mobileNo`;
    }
    return(
      <div>
        <Box loading={loading}>
        <Box.Header border={true}>
            <Box.Title>
                {title}
            </Box.Title>
            <Box.Tools className='pull-right'>
                                   
            </Box.Tools> 
          </Box.Header>
          <Box.Body>
            {this.renderTable()}
            {this.renderNewItemButton()}
            <NotificationSystem ref="notificationSystem" />        
          </Box.Body>
          <Box.Footer>
            <ButtonToolbar className='pull-right'>
              <Button style={{display:(this.props.showSaveButton)?'':'none'}} bsStyle='primary' onClick={this.onSaveClick.bind(this,null)}><FontAwsome name='save' />&nbsp;บันทึก</Button>
              <Button style={{display:'none'}} onClick={this.onCloseClick.bind(this)}><FontAwsome name='close' />&nbsp;ปิดเอกสาร</Button>
            </ButtonToolbar>
          </Box.Footer>
        </Box>    
        <ConfirmPopup
            show={this.state.showConfirm}
            message={'ยืนยันการลบรายการ ?'}
            onHide={()=>{this.setState({showConfirm:false,indexDel:undefined})}}
            onConfirm={this.onConfirmDel.bind(this)}
        />
      </div>
    )
  }
}

NotificationScheduleConfig.defaultProps = {
    mobileNo:'',
    alertType:'SMS',
    refNo:'',
    defaultText:'',
    showSaveButton:false
}


export default NotificationScheduleConfig;








// WEBPACK FOOTER //
// ./src/view/notification/NotificationScheduleConfig.js